// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1i0a8","item":"PaymentsMobile_item__3TOOb","label":"PaymentsMobile_label__3NbEg","amount":"PaymentsMobile_amount__lNoB_"};